<template>
  <div class="web-box-all">
    <ext-header select_menu="6"></ext-header>

    <div class="web-home-main">

      <div class="web-order-box">
        <div class="web-order-left">
            <div class="web-help-nav-box-main">
                <div class="web-help-nav-box" v-for="(vo,index) in help_list" :key="index">
                    <h2>{{vo.title}}</h2>
                    <ul>
                        <li v-for="(voo,key) in vo.more" :key="key" :class="[voo.id==select_id ? 'select' : '']">
                            <a @click="get_link(voo.id)">{{voo.title}}</a>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
        <div class="web-order-right">

          <div class="web-order-title">
            <ul>
              <li class="select">
                <a>帮助信息</a>
              </li>
            </ul>
          </div>

          <div class="web-store-info">
            <div class="web-news-body-main">
                <iframe
                :src="help_url"
                width="100%"
                :height="iframeH"
                frameborder="0"
                scrolling="no"
                ref="iframe"
                ></iframe>
            </div>
          </div>

        </div>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'
export default {
  name: 'store_info',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter
  },
  data () {
    return {
      title: '帮助信息',
      web_url: webUrl(),
      iframeH: '',
      select_id: 0,
      help_list: [],
      help_url: ''
    }
  },
  created () {
    var that = this
    setTimeout(function () {
      that.help_url = webUrl() + '/store/api/web_help_html?id=' + that.select_id
    }, 1500)
  },
  mounted () {
    var params = this.$route.query

    this.load_data()

    if (params.v) {
      this.select_id = Decrypt(params.v)
    } else {
      this.select_id = ''
    }

    var that = this

    let timer = setTimeout(() => {
      that.$nextTick(() => { // 必须在页面加载完成之后获取高
        // iframe自适应高
        that.iframeH = that.$refs.iframe.contentWindow.document.documentElement.scrollHeight || that.$refs.iframe.contentWindow.document.body.scrollHeight
      })
    }, 2300)
    // 清除定时器
    this.$once('hook:beforeDestroy', () => {
      clearInterval(timer)
      timer = null
    })
  },
  methods: {
    get_link (id) {
      var selectId = this.select_id
      if (selectId !== id) {
        this.$router.push({path: '/store/help', query: {v: Encrypt(id)}})
      }
    },
    load_data () {
      var that = this
      ajax({
        url: '/store/api/help_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.help_list = ret.data
        } else {
          that.help_list = []
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
  .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}

  .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-order-title { width:100%; height:50px; border-bottom: 1px solid #dfdfdf;}
      .web-order-title ul { width:400px; height:50px; list-style:none; margin:0px; padding:0px; flex-wrap:wrap; align-content:flex-start;}
      .web-order-title ul li { width:80px; height:50px; cursor: pointer; line-height: 50px; font-size:14px; text-align: center;justify-content:center; }
      .web-order-title ul li a { color:#333333;}
      .web-order-title ul li a:hover { color:#d81e06; font-weight: bold;}
      .web-order-title ul li.select { border-bottom: 2px solid #d81e06;}
   .web-store-info { width:100%; min-height: 402px; flex-wrap:wrap; margin-top:15px; border:1px  solid #dfdfdf; align-content:flex-start;}
      .web-store-info ul { width:100%; height: auto; list-style:none; margin-top:15px; flex-wrap:wrap; align-content:flex-start;}
      .web-store-info ul li { width:100%; height:40px; flex-flow:row; align-content:flex-start;}
      .web-store-info ul li a { width:80px; height:40px; line-height:40px; font-size:14px; color:#333333;}
      .web-store-info ul li p { width:auto; height:40px; line-height:40px; font-size:12px; color:#333333;}

.web-help-nav-box-main { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; border:1px solid #dfdfdf; align-content:flex-start;}
.web-help-nav-box { width:200px; height:auto; flex-wrap:wrap; align-content:flex-start;}
    .web-help-nav-box h2 { width:100%; height:40px; line-height:40px; padding:0px 15px; margin:0px; font-size:14px; font-weight: bold; color:#333333;}
    .web-help-nav-box ul { width:100%; height:auto; list-style:none; margin:0px; padding:0px; flex-wrap:wrap; align-content:flex-start;}
    .web-help-nav-box ul li { width:100%; border-left:3px solid #ffffff; height:auto; cursor: pointer; line-height:35px; padding:0px 15px; color:#333333; font-size:12px; margin:0px;}
    .web-help-nav-box ul li a { width:100%; height:35px; line-height:35px; color:#333333;}
    .web-help-nav-box ul li a:hover { color:#333333;}
    .web-help-nav-box ul li.select { border-left:3px solid #d81e06; background: #fbe1df;}
    .web-help-nav-box ul li:hover { border-left:3px solid #d81e06; background: #fbe1df;}
.web-news-body-main { width:100%; height: auto; flex-wrap:wrap; align-content:flex-start;}

</style>



// WEBPACK FOOTER //
// src/pages/store/help.vue